import React, {Component} from 'react';
import image from "../../images/handwriting.gif";
import {isIOS} from "react-device-detect";
import introVideo from "../../images/handwriting.mp4";
import "./topper.scss";

class Topper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFreshSession:false,
            isVisible:false,
        }
    }
    componentDidMount() {
        if(typeof window !== "undefined"){
            let isFresh = window.sessionStorage.getItem("first-visit");
            if(!this.state.isFreshSession && isFresh === null){
                window.sessionStorage.setItem("first-visit","true")
                this.setState({isFreshSession:true,isVisible:true});
                setTimeout(()=>{
                    document.querySelector("div.layout").style.opacity = "1";
                    this.setState({isFreshSession:false,isVisible:false});
                },4400)
            }else{
                document.querySelector("div.layout").style.opacity = "1";
                this.setState({isFreshSession:false})
            }
        }
    }

    render() {
        return (
            <div className={`topper ${this.state.isVisible ? "visible" : ""}`}>
                {!isIOS &&
                    this.state.isFreshSession ?
                    <video id={"video"}
                    autoPlay
                    muted>
                    <source src={introVideo} type="video/mp4"/>
                    <p> The video didn't load right </p>
                    </video>
                    : this.props.children
                }
                {isIOS &&
                this.state.isFreshSession ?
                    <img
                        src={image}
                        alt="animated gif of handwriting"
                        className={`loader`}
                    />
                    : this.props.children
                }
            </div>
        );
    }
}

export default Topper;